import React, { useEffect, useState } from 'react';

import setUiMessage from '../../Utilities/Tostify';
import { post } from '../Auths/AuthToken';
import SearchStaffUser from '../../Utilities/SerchStafUser';

// Component for a form to tag users
function TagUserForm({ heading, closeDialog, msgI, msgType, tagUserStr }) {
  const [taggedStaff, setTaggedStaff] = useState([]);

  // Fetch tagged staff data on component mount
  useEffect(() => {
    const fetchTaggedStaff = async () => {
      try {
        const response = await post('api/communication/Communication/tagUser', {
          msgId: msgI, // message Id
          msgType: msgType, // 1, 2, 3
        });

        if (response?.status === 200) {
          setTaggedStaff(response?.data?.taggedStaff);
        }
      } catch (e) {
        setUiMessage('err', e.message);
      }
    };

    fetchTaggedStaff();
  }, [msgI, msgType, closeDialog]);

  // Handler for saving tagged staff
  const handleSaveTaggedStaff = async () => {
    const staffIds = taggedStaff?.map((item) => item.staff_id).join(',');

    try {
      const response = await post(
        'api/communication/Communication/saveTagUser',
        {
          msgId: msgI, // message Id
          msgType: msgType,
          attachStaffId: staffIds, // staff id comma separated
          loginUserId: '1',
        }
      );

      if (response?.status === 200) {
        if (response?.data?.statusCode) {
          tagUserStr(response?.data?.taggedUser);
          setUiMessage('suc', 'User tagged successfully');
          closeDialog(false);
        }
        //setTaggedStaff(response?.data?.taggedStaff);
      }
    } catch (e) {
      setUiMessage('err', e.message);
    }
  };

  return (
    <div className="modalBackground">
      <div className="sub-type-popup-box">
        <div className="mentalheader-row sub-type-popup-head">
          <span className="sub-type-popup-head-text">Tag User: {heading}</span>
          <span
            className="sub-type-popup-head-close close"
            onClick={closeDialog}
          >
            X
          </span>
        </div>
        <div className="mentalvaluemainBody">
          <span className="menntal-ad-val-text clear-right10 hide">
            Category:
          </span>
          <span className="menntal-ad-val-text-val">
            {/* SearchStaffUser component for selecting staff */}
            <SearchStaffUser
              key={Math.random()} // Ensure re-rendering when the key changes
              tagStaffUser={taggedStaff}
              handleTaggedStaff={(staffs) => setTaggedStaff(staffs)}
            />
          </span>
          <div
            className=""
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <span
              className="button-submit right"
              style={{ height: '25px', marginRight: '10px' }}
              onClick={handleSaveTaggedStaff}
            >
              Save
            </span>
            <span
              id="tcaddValCancel"
              className="button-cancel2 right clear-right"
              onClick={closeDialog}
            >
              Cancel
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TagUserForm;
